<!--
    描述：投标保证金
    日期：2022/9/26
    创建人：李家宝
-->
<template>
  <div>
    <el-empty description="暂无数据" v-if="tableData.length == 0"></el-empty>
    <template v-else>
      <div>
        当前项目投标报名人数
        <span style="color: #0000FF">{{ tableData.length }}</span
        >人
      </div>
      <div class="mt10">
        <el-table
          :data="tableData"
          highlight-current-row
          row-key="id"
          border
          ref="table"
          style="width: 100%"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="50"
          ></el-table-column>
          <el-table-column label="投标人" show-overflow-tooltip min-width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.bidderName }}</span>
              <span v-if="scope.row.bidderType == 0">（{{
                scope.row.bidderPhone
              }}）</span>
            </template>
          </el-table-column>
          <el-table-column label="类型" align="center" min-width="121">
            <template slot-scope="scope">
              <span>{{ scope.row.bidderType == 0 ? "个人" : "企业" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="所属地区"
            show-overflow-tooltip
            prop="bidderAddress"
            align="center"
            min-width="121"
          ></el-table-column>
          <el-table-column
            prop="registrationTime"
            label="报名时间"
            align="center"
            min-width="160"
          ></el-table-column>
          <el-table-column
            label="投标报价"
            show-overflow-tooltip
            prop="bidOffer"
            align="center"
            min-width="111"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.bidOffer }}元</span>
            </template>
          </el-table-column>
          <el-table-column
            label="投标保证金"
            show-overflow-tooltip
            prop="bidBond"
            align="center"
            min-width="111"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.bidBond }}元</span>
            </template>
          </el-table-column>
          <el-table-column label="投标状态" align="center" min-width="111">
            <template slot-scope="scope">
              <span v-if="scope.row.bidState == 0">报名成功</span>
              <span v-if="scope.row.bidState == 1">中标</span>
              <span v-if="scope.row.bidState == 2">未中标</span>
            </template>
          </el-table-column>
          <el-table-column label="保证金状态" align="center" min-width="111">
            <template slot-scope="scope">
              <span v-if="scope.row.marginRefund == 0">未退还</span>
              <span v-if="scope.row.marginRefund == 1">已退还</span>
              <span v-if="scope.row.marginRefund == 2">--</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="130">
            <template slot-scope="scope">
              <el-button
                size="mini"
                v-if="scope.row.securityDepositStatus == 1 && scope.row.marginRefund == 0"
                @click="refund(scope.row)"
                >退还保证金</el-button
              >
              <!--v-if="scope.row.marginRefund == 0"-->
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="w-table-footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageList"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </template>
    <!--弹窗-->
    <el-dialog
      :visible.sync="auditShow"
      width="40%"
      center
      title="退还保证金"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <div class="dialog-box">
        <div class="mb20">{{ currentRowData.bidderName }}</div>
        <div class="mb20">
          <span style="padding-right: 100px">
            投标状态：
            <span v-if="currentRowData.bidState == 0">报名成功</span>
            <span v-else-if="currentRowData.bidState == 1">中标</span>
            <span v-else-if="currentRowData.bidState == 2">未中标</span>
          </span>
          <span>保证金：{{ currentRowData.bidBond }}</span>
        </div>
        <div class="mb20">
          请确定退还该项目的投标保证金，确定后保证金将按原路退还
        </div>
      </div>
      <div style="text-align: center">
        <el-button class="btn cancel-btn" size="small" @click="closeDialog"
          >取消
        </el-button>
        <el-button
          class="btn btn-blue"
          type="primary"
          size="small"
          :loading="btnLoading"
          @click="submitCheck"
          >提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBidderList, depositReleased } from "api/modules/projectManagement";
import { mapState } from "vuex";
export default {
  name: "bidBond",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapState("user", {
      userInfo: state => state.userInfo
    })
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      tableData: [], // 表格数据
      auditShow: false, // 审核弹窗的显隐
      btnLoading: false,
      currentRowData: {} // 当前行数据
    };
  },
  methods: {
    // 获取列表数据
    getBidderList() {
      getBidderList({
        subProjectId: this.rowData.businessId,
        current: this.currentPage,
        size: this.pageSize
      }).then(res => {
        if (res.operationCode == 1) {
          this.tableData = res.data.records;
          this.currentPage = parseInt(res.data.current);
          this.total = parseInt(res.data.total);
          this.pageSize = parseInt(res.data.size);
        }
      });
    },

    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getBidderList();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getBidderList();
    },

    // 退还保证金
    refund(currentRowData) {
      this.auditShow = true;
      this.currentRowData = currentRowData;
    },

    // 弹窗确定事件
    submitCheck() {
      this.btnLoading = true;
      let parameter = {
        id: this.currentRowData.id,
        identityId: this.userInfo.id
      };
      depositReleased(parameter).then(res => {
        if (res.operationCode == 1) {
          this.btnLoading = false;
          this.auditShow = false;
          this.$message.success("操作成功！");
          this.getBidderList();
        }
      });
    },

    // close 审查弹框
    closeDialog() {
      this.auditShow = false;
    }
  },

  created() {},

  mounted() {}
};
</script>

<style scoped>
.w-table-footer {
  display: flex;
  justify-content: center;
  margin: 20px;
}
.el-button {
  background-color: #199ed8;
  color: white;
}

.dialog-box {
  padding-left: 100px;
}
</style>
